var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcNoisyRoom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 569.8 306.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#fff;}.cls-2{font-size:77px;font-family:Montserrat-SemiBold, Montserrat;font-weight:600;}.cls-3{fill:none;stroke:#6efaff;stroke-linecap:round;stroke-miterlimit:10;stroke-width:4px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "understanding_words2",
    "data-name": "understanding words2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M89.38,150.49,69.52,193.63,62,210l-1.63,3.54L47.87,240.65l2.45-16.79-9,19.52-5.41,11.75-.34.74-1.87,4.06-5.26,11.42L21,287.52A11,11,0,0,1,6.46,292.9l-.08,0A11,11,0,0,1,1,278.31l.54-1.18L15.59,246.6l.74-1.6.81-1.74h0l4.45-9.67,8.64-18.77h0l9.67-21,.68-1.48,2.78-6,.45-1,3.42-7.43,6-13.11,1.48-3.21,2.82-6.13.53-1.15a10.89,10.89,0,0,1,3.78-4.46h0a6.25,6.25,0,0,1,5.91-2.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.94,134.06l-1.78,3.86A39.51,39.51,0,0,1,77.8,114.47a10.68,10.68,0,0,1,5,1l8.81,4.06A11,11,0,0,1,96.94,134.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.12,163.47,66.88,187.89l-7.51,16.32-.26.56-8.78,19.07v0l-9,19.52-5.41,11.75-.34.74-1.87,4.06-5.26,11.42L21,287.52A11,11,0,0,1,6.46,292.9l-.08,0A11,11,0,0,1,1,278.31l.54-1.18L15.59,246.6l.74-1.6.81-1.74h0l4.45-9.67,8.64-18.77h0l9.67-21,.68-1.48,2.78-6,.45-1,3.42-7.43,6-13.11,1.48-3.21,2.82-6.13.53-1.15a10.89,10.89,0,0,1,3.78-4.46h0a11,11,0,0,1,10.77-.92l.08,0A11,11,0,0,1,78.12,163.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M155.41,104.37c0,1.12,0,2.22-.14,3.31a39.44,39.44,0,0,1-37.55,36.11c-.59,0-1.18,0-1.77,0s-1.19,0-1.78,0A39.43,39.43,0,0,1,77.8,114.47a38.85,38.85,0,0,1-1.17-6.79c-.09-1.09-.14-2.19-.14-3.31a38.8,38.8,0,0,1,.22-4.19,39.46,39.46,0,0,1,78.41-.58c0,.26.06.51.09.77C155.34,101.69,155.41,103,155.41,104.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M155.41,104.37c0,1.12,0,2.22-.14,3.31a39.44,39.44,0,0,1-37.55,36.11c-.59,0-1.18,0-1.77,0s-1.19,0-1.78,0A39.43,39.43,0,0,1,77.8,114.47a38.85,38.85,0,0,1-1.17-6.79c-.09-1.09-.14-2.19-.14-3.31a38.8,38.8,0,0,1,.22-4.19,39.46,39.46,0,0,1,78.41-.58c0,.26.06.51.09.77C155.34,101.69,155.41,103,155.41,104.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M144.81,164.89,126.69,289.15a6.27,6.27,0,0,1-7.09,5.29L47.87,284a6.27,6.27,0,0,1-5.28-7.09l5-34.43.26-1.79v0l2.45-16.79v0L54.68,194v0l1.43-9.8v0l2.18-15,2.42-16.59a6.16,6.16,0,0,1,1.17-2.83h0a6.25,6.25,0,0,1,5.91-2.46l21.58,3.15,50.14,7.31A6.29,6.29,0,0,1,144.81,164.89Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 70.73,
    y: 220.86,
    width: 149.43,
    height: 23.42,
    rx: 10.97,
    transform: "translate(360.42 62.19) rotate(83.62)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M155.21,100.36c.13,1.32.2,2.65.2,4,0,1.12,0,2.22-.14,3.31a39.24,39.24,0,0,1-5.41,16.88l-7.37-7.37a11,11,0,0,1,12.63-17.59C155.16,99.85,155.18,100.1,155.21,100.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.55,169.33c0,.49,0,1-.07,1.46a17.32,17.32,0,0,1-8.37,13.44,17.1,17.1,0,0,1-5,2,18.1,18.1,0,0,1-3.15.43c-.26,0-.52,0-.78,0s-.52,0-.78,0a17.69,17.69,0,0,1-3-.41h0l.46-1,3.42-7.43,6-13.11,1.48-3.21,2.82-6.13.21.17a15.6,15.6,0,0,1,2.2,2,17.29,17.29,0,0,1,4.47,9.89A16,16,0,0,1,64.55,169.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.55,169.33c0,.49,0,1-.07,1.46a17.32,17.32,0,0,1-8.37,13.44,17.1,17.1,0,0,1-5,2,18.1,18.1,0,0,1-3.15.43c-.26,0-.52,0-.78,0s-.52,0-.78,0a17.69,17.69,0,0,1-3-.41h0l.46-1,3.42-7.43,6-13.11,1.48-3.21,2.82-6.13.21.17a15.6,15.6,0,0,1,2.2,2,17.29,17.29,0,0,1,4.47,9.89A16,16,0,0,1,64.55,169.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.1,246a6.84,6.84,0,0,1-9-3.34L62,210l-2.64-5.74-.5-1.09L54.68,194v0l-3.57-7.75-3.83-8.31,0-.08,6-13.11,1.48-3.21.11.25,3.43,7.43,4,8.68,4.59,10,2.64,5.74,19.92,43.28A6.84,6.84,0,0,1,86.1,246Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39,217.14c0,.34,0,.68,0,1a11.88,11.88,0,0,1-.75,3.32,12.16,12.16,0,0,1-9.57,7.68l1.6-14.35h0l.05-.46,3.38-7.24.09.06a11.79,11.79,0,0,1,2.73,2.59h0a12.06,12.06,0,0,1,2.43,6.09A10.9,10.9,0,0,1,39,217.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39,217.14c0,.34,0,.68,0,1a11.88,11.88,0,0,1-.75,3.32,12.16,12.16,0,0,1-9.57,7.68l1.6-14.35h0l.05-.46,3.38-7.24.09.06a11.79,11.79,0,0,1,2.73,2.59h0a12.06,12.06,0,0,1,2.43,6.09A10.9,10.9,0,0,1,39,217.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "58.25 262.08 54.53 270.16 47.05 253.91 47.04 253.9 46.54 252.8 45.94 251.51 46.52 250.28 46.52 250.27 49.67 243.42 53.54 251.83 58.25 262.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.43,198.21a5.4,5.4,0,0,1,0,.56l-3.26,29.17-.32,2.86-.19,1.64-.27,2.45h0l-2.13,19a5,5,0,0,1-.3,1.23l-.34.74A5.15,5.15,0,0,1,26,253.33a5.78,5.78,0,0,1,0-.58l2.28-20.42.36-3.17,1.6-14.35h0l.05-.46,3.38-7.24,6.22-13.33h0A5.18,5.18,0,0,1,42.43,198.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M398.1,109a39.46,39.46,0,0,0-78.41-.58c0,.26-.06.51-.09.77-.13,1.32-.2,2.65-.2,4,0,1.12.05,2.22.14,3.31a39.44,39.44,0,0,0,37.55,36.11c.59,0,1.18,0,1.77,0s1.19,0,1.78,0a39.45,39.45,0,0,0,37.54-36.11c.09-1.09.14-2.19.14-3.31A38.8,38.8,0,0,0,398.1,109Zm-46,28.15c-6.86,0-12.42-3.77-12.42-8.41s5.56-8.4,12.42-8.4,12.41,3.76,12.41,8.4S359,137.1,352.12,137.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M398.1,109a39.46,39.46,0,0,0-78.41-.58c0,.26-.06.51-.09.77-.13,1.32-.2,2.65-.2,4,0,1.12.05,2.22.14,3.31a39.44,39.44,0,0,0,37.55,36.11c.59,0,1.18,0,1.77,0s1.19,0,1.78,0a39.45,39.45,0,0,0,37.54-36.11c.09-1.09.14-2.19.14-3.31A38.8,38.8,0,0,0,398.1,109Zm-46,28.15c-6.86,0-12.42-3.77-12.42-8.41s5.56-8.4,12.42-8.4,12.41,3.76,12.41,8.4S359,137.1,352.12,137.1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 338.62,
    y: 160.63,
    width: 84.99,
    height: 138.08,
    rx: 6.25,
    transform: "translate(791.38 401.95) rotate(171.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 272.2,
    y: 158.23,
    width: 79.42,
    height: 23.42,
    rx: 10.97,
    transform: "translate(546.24 436.88) rotate(-159.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 356.31,
    y: 216.76,
    width: 157.88,
    height: 21.95,
    rx: 10.97,
    transform: "translate(410.37 718.33) rotate(-114.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M319.6,109.15c-.13,1.32-.2,2.65-.2,4,0,1.12.05,2.22.14,3.31A39.24,39.24,0,0,0,325,133.34l7.37-7.37a11,11,0,0,0-12.63-17.59C319.65,108.64,319.63,108.89,319.6,109.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M276,166.82a11,11,0,0,0,15.52,0l26.66-26.66a48.49,48.49,0,0,1-8-22.91s0-.09,0-.14L276,151.3A11,11,0,0,0,276,166.82Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(270.21 130.13) rotate(-35.26)"
  }, "?"), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(297.77 79.27) rotate(-35.26)"
  }, "?"), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M480.62,128.14s-15.3-12.21,0-22.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M474,135.9s-26.07-20.79,0-37.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M462.37,144.32s-37.76-30.11,0-54.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M449.69,157.62s-56.21-44.82,0-81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M558.1,191.46s-15.31-12.21,0-22.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M551.43,199.22s-26.07-20.79,0-37.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M539.84,207.64s-37.75-30.11,0-54.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M527.16,220.94s-56.2-44.82,0-81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M567.8,80.88s-15.31-12.21,0-22.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M561.13,88.64s-26.07-20.79,0-37.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M549.54,97.06s-37.75-30.11,0-54.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M536.86,110.36s-56.2-44.82,0-81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M170.22,100.66s15.82,11.52,1,22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M176.54,92.61s27,19.63,1.65,37.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M187.75,83.69s39,28.43,2.38,54.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M199.83,69.85s58.11,42.32,3.55,81"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNoisyRoom);
export default __webpack_public_path__ + "static/media/ic_noisyRoom.0a975b72a1bc123d7148be461be329d3.svg";
export { ForwardRef as ReactComponent };